(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-filter"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initEhCatArrows(root) {
    var scope = root || document;
    var scrollers = scope.querySelectorAll('.eh-cat__scroller');

    scrollers.forEach(function (scroller) {
      if (scroller.dataset.ehCatArrowsInit === 'true') return;
      scroller.dataset.ehCatArrowsInit = 'true';

      var list = scroller.querySelector('.eh-cat__list');
      var leftArrow = scroller.querySelector('.eh-cat__arrow--left');
      var rightArrow = scroller.querySelector('.eh-cat__arrow--right');

      if (!list || !leftArrow || !rightArrow) return;

      function updateArrows() {
        var maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
        var currentScroll = Math.max(0, list.scrollLeft);
        var canScroll = maxScroll > 3;

        var hasLeft = canScroll && currentScroll > 4;
        var hasRight = canScroll && currentScroll < maxScroll - 4;

        scroller.classList.toggle('has-left', hasLeft);
        scroller.classList.toggle('has-right', hasRight);

        leftArrow.disabled = !hasLeft;
        rightArrow.disabled = !hasRight;
      }

      function scrollList(direction) {
        var amount = Math.max(140, list.clientWidth * 0.65);
        var maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
        var target = list.scrollLeft + (amount * direction);
        target = Math.max(0, Math.min(target, maxScroll));
        list.scrollTo({
          left: target,
          behavior: 'smooth'
        });
      }

      leftArrow.addEventListener('click', function () {
        scrollList(-1);
      });

      rightArrow.addEventListener('click', function () {
        scrollList(1);
      });

      list.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);

      if (window.ResizeObserver) {
        var observer = new ResizeObserver(updateArrows);
        observer.observe(list);
        observer.observe(scroller);
      }

      requestAnimationFrame(updateArrows);
      setTimeout(updateArrows, 300);
      setTimeout(updateArrows, 800);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initEhCatArrows(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initEhCatArrows(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
